module.exports = __webpack_public_path__ + "static/media/dungeon_floor_n2.bbc9202d.png";